/* LECHI Luxe — sale display window (snippets/sale-promotion.liquid, price.liquid, product-card.liquid).
   Shopify may serve a cached page; every sale element carries its promotion's start / end (Unix seconds), so
   outside that window the regular price is shown and SALE badges and notes are hidden. Nothing is priced here:
   Shopify applies the real discount in the cart and at checkout. */
(() => {
  if (window.lechiPromotions) return;
  const active = (el) => {
    const now = Date.now() / 1000;
    const starts = Number(el.dataset.promoStarts) || 0;
    const ends = Number(el.dataset.promoEnds) || 0;
    return (!starts || now >= starts) && (!ends || now < ends);
  };
  const apply = (root = document) => {
    root.querySelectorAll('[data-promo]').forEach((el) => {
      const on = active(el);
      const onPart = el.querySelector(':scope > [data-promo-on]');
      const offPart = el.querySelector(':scope > [data-promo-off]');
      if (onPart || offPart) {
        if (onPart) onPart.hidden = !on;
        if (offPart) offPart.hidden = on;
        // Only the visible price keeps .price__regular (the sticky purchase bar mirrors the first one)
        onPart?.querySelectorAll('.price__regular, .price__regular-off').forEach((price) => {
          price.classList.toggle('price__regular', on);
          price.classList.toggle('price__regular-off', !on);
        });
        el.classList.toggle('price--promo-active', on);
      } else {
        el.hidden = !on;
      }
    });
  };
  window.lechiPromotions = { apply, active };
  const start = () => {
    apply();
    // Re-rendered price areas (variant changes, cart drawer) and a sale that ends while the page is open
    new MutationObserver(() => apply()).observe(document.body, { childList: true, subtree: true });
    setInterval(apply, 30000);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
